import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Container, MenuItem } from './styles';
import FolderTabDetails from '../../containers/SidebarMenu/FolderTabDetails';
import AddTagsModal from '../Modals/AddTagsModal';
import { AppStoreContext } from '../../context/appStoreContext';
import { MANAGE_TAGS_AND_FOLDER } from './translationValues';

const NAMESPACES = ['MANAGE_TAGS_AND_FOLDER'];
class FileDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
      modalVisible: false,
      template: {},
    };
  }

  static contextType = AppStoreContext;

  selectHandler = id => {
    if (id === 2) {
      this.setState({
        modalVisible: true,
        tabIndex: id,
      });
    } else {
      this.setState({
        tabIndex: id,
      });
    }
  };

  previousHandler = () => {
    this.setState({
      tabIndex: 0,
    });
  };

  findOutTemplate = () => {
    const { categoryTemplates } = this.context;
    const { template } = this.props;
    if (categoryTemplates.length === 0) {
      this.setState({
        template: template,
      });
    } else {
      if (template.categoryId && template.id) {
        const categoryIndex = categoryTemplates.findIndex(
          category => category.categoryId === template.categoryId,
        );
        if (categoryIndex >= 0) {
          const target = categoryTemplates[categoryIndex].templates.filter(
            templateDetails => templateDetails.id === template.id,
          );
          this.setState({
            template: target[0],
          });
        }
      }
    }
  };

  modalCloseHandler = () => {
    this.setState({
      modalVisible: false,
      tabIndex: 0,
    });
  };

  render() {
    const { t, isRefElement, isEmailTemp, isShortMessageTemp, shortMsgTempDetails } = this.props;
    const { tabIndex, modalVisible, template } = this.state;
    const { elementDetails } = this.context;
    return (
      <>
        <Container onMouseEnter={this.findOutTemplate}>
          {!modalVisible && tabIndex === 0 && (
            <div>
              {!isShortMessageTemp && 
                  !isRefElement &&
                  <MenuItem onClick={() => this.selectHandler(1)}>
                    <div>{t(MANAGE_TAGS_AND_FOLDER.SAVE_TO_FOLDER_BUTTON.key, MANAGE_TAGS_AND_FOLDER.SAVE_TO_FOLDER_BUTTON.value)}</div>
                  </MenuItem>
              }
              <MenuItem onClick={() => this.selectHandler(2)}>
                <div>{t(MANAGE_TAGS_AND_FOLDER.MANAGE_TAGS_BUTTON.key, MANAGE_TAGS_AND_FOLDER.MANAGE_TAGS_BUTTON.value)}</div>
              </MenuItem>
            </div>
          )}
          {!modalVisible && tabIndex === 1 && (
            <FolderTabDetails handlePrevious={this.previousHandler} template={template} isSaveFolder={true} isEmail={isEmailTemp}/>
          )}
        </Container>
        {modalVisible && tabIndex === 2 && (
          <AddTagsModal
            visible={modalVisible}
            target={
              isRefElement ? elementDetails : isShortMessageTemp ? shortMsgTempDetails : template
            }
            onCancel={this.modalCloseHandler}
            isEmail={isEmailTemp}
            isShortMessage={isShortMessageTemp}
            isElement={isRefElement}
          />
        )}
      </>
    );
  }
}

export default withTranslation(NAMESPACES)(FileDropdown);
